export const FETCH__INVESTMENT_DETAILS = 'FETCH__INVESTMENT_DETAILS';
export const FETCH__INVESTMENT_DETAILS__SUCCESS = 'FETCH__INVESTMENT_DETAILS__SUCCESS';
export const FETCH__INVESTMENT_DETAILS__FAIL = 'FETCH__INVESTMENT_DETAILS__FAIL';

export const FETCH__ACCOUNT_STATEMENTS = 'FETCH__ACCOUNT_STATEMENTS';
export const FETCH__ACCOUNT_STATEMENTS__SUCCESS = 'FETCH__ACCOUNT_STATEMENTS__SUCCESS';
export const FETCH__ACCOUNT_STATEMENTS__FAIL = 'FETCH__ACCOUNT_STATEMENTS__FAIL';